import { Recycle, ShieldCheck, Leaf } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const SUS_ICONS = [Recycle, ShieldCheck, Leaf];

export default function ProductIntro() {
  const { t } = useT();
  return (
    <section
      id="product"
      data-testid="product-intro"
      className="relative border-b border-white/10 bg-[#0A0A0A]"
    >
      <div className="grid grid-cols-12">
        <div className="col-span-12 md:col-span-3 border-r border-white/10 px-6 sm:px-8 py-10 md:py-20 flex flex-col gap-6">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50">
            {t.product.label}
          </p>
          <p className="font-display text-xs uppercase tracking-[0.25em] text-white/70">
            {t.product.sideTitle.map((line, i) => (
              <span key={i}>
                {line}
                {i < t.product.sideTitle.length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>

        <div className="col-span-12 md:col-span-9 px-6 sm:px-10 py-10 md:py-20">
          <h2
            data-testid="product-headline"
            className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-4xl"
          >
            {t.product.headlineL1}
            <br />
            <span className="text-white/40">{t.product.headlineL2}</span>
            <br />
            {t.product.headlineL3}
          </h2>

          <div className="grid grid-cols-12 gap-8 mt-12">
            <p className="col-span-12 md:col-span-6 text-base text-white/70 leading-relaxed">
              {t.product.body1}
            </p>
            <p className="col-span-12 md:col-span-6 text-base text-white/70 leading-relaxed">
              {t.product.body2}
            </p>
            <p className="col-span-12 text-base text-white/60 leading-relaxed border-t border-white/10 pt-6 mt-2 max-w-3xl">
              {t.product.body3}
            </p>
            <p className="col-span-12 text-base text-white/60 leading-relaxed border-t border-white/10 pt-6 max-w-3xl">
              {t.product.body4}
            </p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-12 border-t border-white/10">
        {t.product.stats.map((s, i) => (
          <div
            key={i}
            className={`col-span-6 md:col-span-3 px-6 sm:px-8 py-10 ${
              i < 3 ? "md:border-r" : ""
            } border-white/10 ${i < 2 ? "border-b md:border-b-0" : ""}`}
          >
            <p className="font-display text-3xl sm:text-4xl font-light text-white tracking-tighter">
              {s.k}
            </p>
            <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 mt-2">
              {s.v}
            </p>
            <p className="text-sm text-white/60 mt-3">{s.l}</p>
          </div>
        ))}
      </div>

      {/* Sustainability cards (relocated from former section 07) */}
      <div className="grid grid-cols-12 border-t border-white/10">
        {t.product.sustainability.map((it, i) => {
          const Icon = SUS_ICONS[i] || Leaf;
          return (
            <div
              key={i}
              data-testid={`sustainability-item-${i}`}
              className={`col-span-12 md:col-span-4 px-6 sm:px-10 py-10 md:py-14 ${
                i < 2 ? "md:border-r" : ""
              } border-white/10 ${i < 2 ? "border-b md:border-b-0" : ""} group`}
            >
              <Icon
                size={24}
                strokeWidth={1.25}
                className="text-white/60 group-hover:text-white transition-colors"
              />
              <p className="font-display text-4xl sm:text-5xl font-light text-white tracking-tighter mt-6">
                {it.k}
              </p>
              <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 mt-3">
                {it.v}
              </p>
              <p className="text-sm text-white/60 mt-4 leading-relaxed">{it.l}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
